import { Trans as I18nTrans, useTranslation } from 'react-i18next'

interface TransProps extends React.ComponentProps<typeof I18nTrans> {
  ns?: string | string[]
}

export const Trans = ({ i18nKey, ns = 'translation', children, ...rest }: TransProps) => {
  const { t } = useTranslation(ns)
  return (
    <I18nTrans i18nKey={i18nKey} ns={ns} t={t} {...rest}>
      {children}
    </I18nTrans>
  )
}
